<template>
  <div class="flex w-full items-stretch">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>
